import { useState, useEffect } from 'react';

const QUANTITY_DAYS = 1;
const DAYS_MS = QUANTITY_DAYS * 24 * 60 * 60 * 1000;

export const useModalControl = () => {
  const [showModalInfo, setShowModalInfo] = useState(false);
  useEffect(() => {
    const lastShown = localStorage.getItem('modalLastShown');
    const now = Date.now();
    if (!lastShown || now - parseInt(lastShown, 10) > DAYS_MS) {
      setShowModalInfo(true);
      localStorage.setItem('modalLastShown', now.toString());
    }
  }, []);
  return [showModalInfo, setShowModalInfo] as const;
}